import {Component, Input, OnInit} from '@angular/core';
import {TableSearcherService} from './table-searcher.service';
import {TableSearcherTypesEnum} from './table-seacher-types.enum';
import {EventsService} from './event.service';
import {Observable} from 'rxjs/Observable';
import'rxjs/add/observable/fromEvent';
import'rxjs/add/operator/filter';
import'rxjs/add/operator/debounceTime';
import'rxjs/add/operator/switch';
import'rxjs/add/operator/do';
import'rxjs/add/observable/throw';
import'rxjs/add/operator/map';
import {TableSearcherInterface} from './table-searcher.interface';
export class TableSearcherComponent implements OnInit {
private static defaultAllSettings: TableSearcherInterface<Object> = {
    path: null,
    placeholder: 'What are you looking for?',
    data: [],
    searchKeys: [],
    from: null,
    queryField: 'search',
    borderColor: '#eee000',
    buttonColor: '#83e6bc',
    searchType: TableSearcherTypesEnum.EMPTY_TABLE_APPLY_BACKEND
  };

   allSettings: TableSearcherInterface<Object> = {
    path: null,
    placeholder: 'What are you looking for?',
    data: [],
    searchKeys: [],
    from: null,
    queryField: 'search',
    borderColor: '#eee000',
    buttonColor: '#83e6bc',
    searchType: TableSearcherTypesEnum.EMPTY_TABLE_APPLY_BACKEND
  };
public searching = false;
private copyData = [];
/**
 * @param {?} tableSearcherService
 * @param {?} eventsService
 */
constructor(private tableSearcherService: TableSearcherService,
private eventsService: EventsService) {
  }
/**
 * This is used to set the border color for the div
 * @return {?}
 */
public setBorderColor() {
    return {'border-bottom': '3px solid ' + this.allSettings.borderColor};
  }
/**
 * This is used to style the button background
 * @return {?}
 */
public setButtonColor() {
    return {'background': this.allSettings.buttonColor};
  }
/**
 * This is used to initialize searching on a table.
 * @param {?} query
 * @return {?}
 */
doSearch(query) {
    if (!query) {
      return null;
    }
    this.searching = true;
    setTimeout(() => {
      switch (this.allSettings.searchType) {
        case TableSearcherTypesEnum.EMPTY_TABLE_APPLY_BACKEND:
          this.processSearching(TableSearcherTypesEnum.EMPTY_TABLE_APPLY_BACKEND, query);
          break;
        case TableSearcherTypesEnum.ON_BACKEND:
          this.doSearchBackend(query);
          break;
        case TableSearcherTypesEnum.ON_TABLE:
          this.processSearching(TableSearcherTypesEnum.ON_TABLE, query);
          break;
        default:
          Observable.throw('Unknown search type');
          break;
      }
    }, 200);
  }
/**
 * This is used to search query strings
 * @param {?} type
 * @param {?} query
 * @return {?}
 */
private processSearching(type, query) {
    this.tableSearcherService.initSearch(this.allSettings.data, query, this.allSettings.searchKeys)
      .subscribe(
        (result) => {
          // console.log('saerchResult=', result);
          if (result.length === 0 && type === TableSearcherTypesEnum.EMPTY_TABLE_APPLY_BACKEND) {
            this.doSearchBackend(query);
            return;
          }
          this.eventsService.broadcast(this.allSettings.from, {result: result, data: this.copyData});
          this.searching = false;
          // console.log('searching=', this.searching);
        },
        (err) => {
          this.searching = false;
          Observable.throw(err);
        }
      );
  }
/**
 * This is used to make a request to a backend api for searching.
 * @param {?} query
 * @return {?}
 */
private doSearchBackend(query) {
    const /** @type {?} */ pos = this.allSettings.path.indexOf('?');
    const /** @type {?} */ path = (pos > -1) ? this.allSettings.path + `&${this.allSettings.queryField}=${query}` : this.allSettings.path + `?${this.allSettings.queryField}=${query}`;
    this.tableSearcherService.searchResource(path)
      .subscribe(
        (res) => {
          this.eventsService.broadcast(this.allSettings.from, {result: res, data: this.copyData});
          this.searching = false;
        },
        (err) => {
          this.searching = false;
          Observable.throw(err);
        }
      );
  }
/**
 * This is used to validate object passed down to table searcher.
 * @return {?}
 */
ValidateSettings() {
    for (const /** @type {?} */ key in this.allSettings) {
      if (!this.allSettings[key]) {
        this.allSettings[key] = TableSearcherComponent.defaultAllSettings[key];
      }
    }
  }
/**
 * @return {?}
 */
ngOnInit() {
    this.ValidateSettings();
    this.copyData = JSON.parse(JSON.stringify(this.allSettings.data));
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-table-searcher',
  template: `
    <div class="table-searcher" [ngStyle]="setBorderColor()" [class.disabled]="searching">
      <input [disabled]="searching" (keyup.enter)="doSearch(searchItem.value)" #searchItem  type="text"  placeholder="{{allSettings.placeholder}}">
      <!--<i *ngIf="searching" class="fa fa-spin fa-spinner"></i>-->
      <button  [disabled]="searching" type="button" (click)="doSearch(searchItem.value)" class="button" [ngStyle]="setButtonColor()">
        <i *ngIf="searching" class="fa fa-spin fa-spinner"></i> <i class="fa fa-search"></i>
      </button>
    </div>
    <span class="clearOut"></span>
  `,
  styles: [`
    input {
      width: 80% !important;
      border: 0 !important;
      height: 20px !important;
      padding: 5px !important;
    }

    input:visited, input:active, input:link, input:after, input:hover, input:focus, button:focus {
      border: 0 !important;
      outline: none;
    }

    .table-searcher {
      border-radius: 5px !important;
      -moz-border-radius: 5px !important;
      -webkit-border-radius: 5px !important;
      width: 100% !important;
      color: #000;
      border: 1px solid #ccc;
      border-bottom: 3px solid #eee000;
      padding: 0 !important;
      margin: 0 !important;
      font-size: 11px !important;
    }

    .disabled {
      background: rgb(235, 235, 228) !important;
    }

    .button {
      background: #83e6bc;
      padding: 9px !important;
      color: #fff !important;
      border: 0 !important;
      cursor: pointer !important;
      font-size: 11px;
      float: right;
      border-radius: 0 5px 5px 0  !important;
      -moz-border-radius: 0 5px 5px 0 !important;
      -webkit-border-radius: 0 5px 5px 0 !important;
    }
    .clearOut {
      clear: both;
    }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TableSearcherService, },
{type: EventsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allSettings': [{ type: Input },],
};
}

function TableSearcherComponent_tsickle_Closure_declarations() {
/** @type {?} */
TableSearcherComponent.defaultAllSettings;
/** @type {?} */
TableSearcherComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TableSearcherComponent.ctorParameters;
/** @type {?} */
TableSearcherComponent.propDecorators;
/** @type {?} */
TableSearcherComponent.prototype.allSettings;
/** @type {?} */
TableSearcherComponent.prototype.searching;
/** @type {?} */
TableSearcherComponent.prototype.copyData;
/** @type {?} */
TableSearcherComponent.prototype.tableSearcherService;
/** @type {?} */
TableSearcherComponent.prototype.eventsService;
}





interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
